<template>
  <div class="report-container">
    <!-- 项目总览模块 -->
    <div class="module">
      <h2 class="section-title" style="padding-top: 25px;">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
          style="margin-left: -15px;">
          <g id="Monitor_Measure">
            <path id="Subtract" opacity="0.5"
              d="M5.8335 15.4167V17.0834C5.8335 17.5436 6.20659 17.9167 6.66683 17.9167H13.3335C13.7937 17.9167 14.1668 17.5436 14.1668 17.0834V15.4167H5.8335Z"
              fill="#1677FF" />
            <rect id="Rectangle 34624959" opacity="0.5" x="5.2085" y="6.67291" width="2.08333" height="4.59836"
              rx="0.416667" fill="#1677FF" />
            <rect id="Rectangle 34626242" opacity="0.5" x="8.9585" y="5.39514" width="2.08333" height="5.87636"
              rx="0.416667" fill="#1677FF" />
            <path id="Subtract_2" fill-rule="evenodd" clip-rule="evenodd"
              d="M2.49984 2.08331C2.0396 2.08331 1.6665 2.45641 1.6665 2.91665V14.5833C1.6665 15.0436 2.0396 15.4166 2.49984 15.4166H17.4999C17.9602 15.4166 18.3333 15.0436 18.3333 14.5833V2.91665C18.3333 2.45641 17.9602 2.08331 17.4999 2.08331H2.49984ZM5.62504 6.67295C5.39492 6.67295 5.20837 6.8595 5.20837 7.08962V10.8546C5.20837 11.0848 5.39492 11.2713 5.62504 11.2713H6.87504C7.10516 11.2713 7.29171 11.0848 7.29171 10.8546V7.08962C7.29171 6.8595 7.10516 6.67295 6.87504 6.67295H5.62504ZM8.95837 5.81175C8.95837 5.58163 9.14492 5.39508 9.37504 5.39508H10.625C10.8552 5.39508 11.0417 5.58163 11.0417 5.81175V10.8548C11.0417 11.0849 10.8552 11.2714 10.625 11.2714H9.37504C9.14492 11.2714 8.95837 11.0849 8.95837 10.8548V5.81175ZM13.125 6.6729C12.8949 6.6729 12.7084 6.85945 12.7084 7.08957V10.8545C12.7084 11.0846 12.8949 11.2711 13.125 11.2711H14.375C14.6052 11.2711 14.7917 11.0846 14.7917 10.8545V7.08957C14.7917 6.85945 14.6052 6.6729 14.375 6.6729H13.125Z"
              fill="#1677FF" />
          </g>
        </svg>项目总览
      </h2>
      <div class="module-content">
        <div class="column">
          <div class="row">
            <div class="data-card">
              <div class="data-label">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="vuesax/bold/frame">
                    <g id="frame">
                      <path id="Vector"
                        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
                        fill="#1677FF" />
                      <path id="Vector_2"
                        d="M17.08 14.15C14.29 12.29 9.73996 12.29 6.92996 14.15C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91996 20.59C8.31996 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z"
                        fill="#1677FF" />
                    </g>
                  </g>
                </svg>昨日入组(人)
              </div>
              <div class="data-value">{{ viewInfoData1["yesterday_pass"] }}</div>
            </div>
            <div class="data-card">
              <div class="data-label"><svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="vuesax/bold/profile-2user">
                    <g id="profile-2user">
                      <path id="Vector"
                        d="M9.6665 2C7.0465 2 4.9165 4.13 4.9165 6.75C4.9165 9.32 6.9265 11.4 9.5465 11.49C9.6265 11.48 9.7065 11.48 9.7665 11.49C9.7865 11.49 9.7965 11.49 9.8165 11.49C9.8265 11.49 9.8265 11.49 9.8365 11.49C12.3965 11.4 14.4065 9.32 14.4165 6.75C14.4165 4.13 12.2865 2 9.6665 2Z"
                        fill="#1677FF" />
                      <path id="Vector_2"
                        d="M14.7465 14.15C11.9565 12.29 7.40646 12.29 4.59646 14.15C3.32646 15 2.62646 16.15 2.62646 17.38C2.62646 18.61 3.32646 19.75 4.58646 20.59C5.98646 21.53 7.82646 22 9.66646 22C11.5065 22 13.3465 21.53 14.7465 20.59C16.0065 19.74 16.7065 18.6 16.7065 17.36C16.6965 16.13 16.0065 14.99 14.7465 14.15Z"
                        fill="#1677FF" />
                      <path id="Vector_3"
                        d="M20.6564 7.33998C20.8164 9.27998 19.4364 10.98 17.5264 11.21C17.5164 11.21 17.5164 11.21 17.5064 11.21H17.4764C17.4164 11.21 17.3564 11.21 17.3064 11.23C16.3364 11.28 15.4464 10.97 14.7764 10.4C15.8064 9.47998 16.3964 8.09998 16.2764 6.59998C16.2064 5.78998 15.9264 5.04998 15.5064 4.41998C15.8864 4.22998 16.3264 4.10998 16.7764 4.06998C18.7364 3.89998 20.4864 5.35998 20.6564 7.33998Z"
                        fill="#1677FF" />
                      <path id="Vector_4"
                        d="M22.6567 16.59C22.5767 17.56 21.9567 18.4 20.9167 18.97C19.9167 19.52 18.6567 19.78 17.4067 19.75C18.1267 19.1 18.5467 18.29 18.6267 17.43C18.7267 16.19 18.1367 15 16.9567 14.05C16.2867 13.52 15.5067 13.1 14.6567 12.79C16.8667 12.15 19.6467 12.58 21.3567 13.96C22.2767 14.7 22.7467 15.63 22.6567 16.59Z"
                        fill="#1677FF" />
                    </g>
                  </g>
                </svg>当月入组(人)</div>
              <div class="data-value">{{ viewInfoData1["month_pass"] }}</div>
            </div>
            <div class="data-card" style="margin-right: 15px;">
              <div class="data-label"><svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="vuesax/bold/people">
                    <g id="people">
                      <path id="Vector"
                        d="M17.8635 7.77C17.7935 7.76 17.7235 7.76 17.6535 7.77C16.1035 7.72 14.8735 6.45 14.8735 4.89C14.8735 3.3 16.1635 2 17.7635 2C19.3535 2 20.6535 3.29 20.6535 4.89C20.6435 6.45 19.4135 7.72 17.8635 7.77Z"
                        fill="#1677FF" />
                      <path id="Vector_2"
                        d="M21.1236 14.7C20.0036 15.45 18.4336 15.73 16.9836 15.54C17.3636 14.72 17.5636 13.81 17.5736 12.85C17.5736 11.85 17.3536 10.9 16.9336 10.07C18.4136 9.86998 19.9836 10.15 21.1136 10.9C22.6936 11.94 22.6936 13.65 21.1236 14.7Z"
                        fill="#1677FF" />
                      <path id="Vector_3"
                        d="M6.77365 7.77C6.84365 7.76 6.91365 7.76 6.98365 7.77C8.53365 7.72 9.76365 6.45 9.76365 4.89C9.76365 3.29 8.47365 2 6.87365 2C5.28365 2 3.99365 3.29 3.99365 4.89C3.99365 6.45 5.22365 7.72 6.77365 7.77Z"
                        fill="#1677FF" />
                      <path id="Vector_4"
                        d="M6.88361 12.85C6.88361 13.82 7.09361 14.74 7.47361 15.57C6.06361 15.72 4.59361 15.42 3.51361 14.71C1.93361 13.66 1.93361 11.95 3.51361 10.9C4.58361 10.18 6.09361 9.88998 7.51361 10.05C7.10361 10.89 6.88361 11.84 6.88361 12.85Z"
                        fill="#1677FF" />
                      <path id="Vector_5"
                        d="M12.4533 15.87C12.3733 15.86 12.2833 15.86 12.1933 15.87C10.3533 15.81 8.8833 14.3 8.8833 12.44C8.8933 10.54 10.4233 9 12.3333 9C14.2333 9 15.7733 10.54 15.7733 12.44C15.7633 14.3 14.3033 15.81 12.4533 15.87Z"
                        fill="#1677FF" />
                      <path id="Vector_6"
                        d="M9.2033 17.94C7.6933 18.95 7.6933 20.61 9.2033 21.61C10.9233 22.76 13.7433 22.76 15.4633 21.61C16.9733 20.6 16.9733 18.94 15.4633 17.94C13.7533 16.79 10.9333 16.79 9.2033 17.94Z"
                        fill="#1677FF" />
                    </g>
                  </g>
                </svg>总共入组(人)</div>
              <div class="data-value">{{ viewInfoData1["year_pass"] }}</div>
            </div>
          </div>
          <div class="row">
            <div ref="passGroupCenterChart" class="chart-1"></div>
          </div>
        </div>
        <div class="column">
          <div ref="monthEnrollChart" class="chart"></div>
          <div class="timeButtons">
            <!-- <button class="time-btn" :class="{ active: currentType === type.value }" data-type="month">月</button>
            <button class="time-btn" data-type="week">周</button>
            <button class="time-btn" data-type="quarter">季度</button>
            <button class="time-btn" data-type="year">年</button> -->
            <button v-for="type in buttonTypes" :key="type.value" :class="{ active: currentType === type.value }"
              @click="handleTypeChange(type.value)">
              {{ type.label }}
            </button>
          </div>
        </div>
        <div class="column">
          <div ref="periodRateChart" class="chart" style="margin-left: 0"></div>
        </div>
      </div>
    </div>

    <!-- 本中心入组模块 -->
    <div class="module" style="height: 413px;">

      <h2 class="section-title">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
          style="margin-left: -15px;">
          <g id="Other_Toolset">
            <path id="Vector 5701" opacity="0.5"
              d="M1.6665 6.62445V3.33333C1.6665 2.8731 2.0396 2.5 2.49984 2.5H17.5001C17.9603 2.5 18.3334 2.8731 18.3334 3.33333V6.62444C18.3334 7.08468 17.9603 7.45778 17.5001 7.45778H2.49984C2.0396 7.45778 1.6665 7.08468 1.6665 6.62445Z"
              fill="#1677FF" />
            <path id="Subtract" fill-rule="evenodd" clip-rule="evenodd"
              d="M2.68799 16.6667V7.45776H17.3116V16.6667C17.3116 17.1269 16.9385 17.5 16.4783 17.5H3.52132C3.06108 17.5 2.68799 17.1269 2.68799 16.6667ZM12.0831 11.7192C12.3132 11.7192 12.4998 11.5327 12.4998 11.3026V10.4692C12.4998 10.2391 12.3132 10.0526 12.0831 10.0526H7.91646C7.68634 10.0526 7.4998 10.2391 7.4998 10.4692V11.3026C7.4998 11.5327 7.68635 11.7192 7.91646 11.7192H12.0831Z"
              fill="#1677FF" />
          </g>
        </svg>本中心入组
      </h2>
      <div class="module-content">
        <div class="column">
          <div class="row">
            <span class="title-font">{{ this.currentCenter != null ? this.currentCenter.name :
              projectUserInfo.center_name }}</span>
            <span class="switch-center" @click="selectCenter">
              切换中心<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="arrow-2">
                  <g id="vuesax/linear/arrow-2">
                    <g id="arrow-2_2">
                      <g id="Group">
                        <g id="Vector">
                          <path d="M11.52 6.96672L14 4.48669L11.52 2.00671" fill="#1677FF" />
                          <path d="M11.52 6.96672L14 4.48669L11.52 2.00671" stroke="#1677FF" stroke-width="1.5"
                            stroke-linecap="round" stroke-linejoin="round" />
                        </g>
                        <path id="Vector_2" d="M2 4.48669H14" stroke="#1677FF" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path id="Vector_3" d="M4.47998 9.03333L2 11.5133L4.47998 13.9933" stroke="#1677FF"
                          stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path id="Vector_4" d="M14 11.5134H2" stroke="#1677FF" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>

            </span>
          </div>
          <div class="row">
            <div class="data-card">
              <div class="data-label">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="vuesax/bold/frame">
                    <g id="frame">
                      <path id="Vector"
                        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
                        fill="#1677FF" />
                      <path id="Vector_2"
                        d="M17.08 14.15C14.29 12.29 9.73996 12.29 6.92996 14.15C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91996 20.59C8.31996 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z"
                        fill="#1677FF" />
                    </g>
                  </g>
                </svg>昨日入组(人)
              </div>
              <div class="data-value">{{ viewInfoData2["yesterday_pass"] }}</div>
            </div>
            <div class="data-card">
              <div class="data-label"><svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="vuesax/bold/profile-2user">
                    <g id="profile-2user">
                      <path id="Vector"
                        d="M9.6665 2C7.0465 2 4.9165 4.13 4.9165 6.75C4.9165 9.32 6.9265 11.4 9.5465 11.49C9.6265 11.48 9.7065 11.48 9.7665 11.49C9.7865 11.49 9.7965 11.49 9.8165 11.49C9.8265 11.49 9.8265 11.49 9.8365 11.49C12.3965 11.4 14.4065 9.32 14.4165 6.75C14.4165 4.13 12.2865 2 9.6665 2Z"
                        fill="#1677FF" />
                      <path id="Vector_2"
                        d="M14.7465 14.15C11.9565 12.29 7.40646 12.29 4.59646 14.15C3.32646 15 2.62646 16.15 2.62646 17.38C2.62646 18.61 3.32646 19.75 4.58646 20.59C5.98646 21.53 7.82646 22 9.66646 22C11.5065 22 13.3465 21.53 14.7465 20.59C16.0065 19.74 16.7065 18.6 16.7065 17.36C16.6965 16.13 16.0065 14.99 14.7465 14.15Z"
                        fill="#1677FF" />
                      <path id="Vector_3"
                        d="M20.6564 7.33998C20.8164 9.27998 19.4364 10.98 17.5264 11.21C17.5164 11.21 17.5164 11.21 17.5064 11.21H17.4764C17.4164 11.21 17.3564 11.21 17.3064 11.23C16.3364 11.28 15.4464 10.97 14.7764 10.4C15.8064 9.47998 16.3964 8.09998 16.2764 6.59998C16.2064 5.78998 15.9264 5.04998 15.5064 4.41998C15.8864 4.22998 16.3264 4.10998 16.7764 4.06998C18.7364 3.89998 20.4864 5.35998 20.6564 7.33998Z"
                        fill="#1677FF" />
                      <path id="Vector_4"
                        d="M22.6567 16.59C22.5767 17.56 21.9567 18.4 20.9167 18.97C19.9167 19.52 18.6567 19.78 17.4067 19.75C18.1267 19.1 18.5467 18.29 18.6267 17.43C18.7267 16.19 18.1367 15 16.9567 14.05C16.2867 13.52 15.5067 13.1 14.6567 12.79C16.8667 12.15 19.6467 12.58 21.3567 13.96C22.2767 14.7 22.7467 15.63 22.6567 16.59Z"
                        fill="#1677FF" />
                    </g>
                  </g>
                </svg>当月入组(人)
              </div>
              <div class="data-value">{{ viewInfoData2["month_pass"] }}</div>
            </div>
            <div class="data-card" style="margin-right: 15px;">
              <div class="data-label"><svg width="25" height="24" viewBox="0 0 25 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <g id="vuesax/bold/people">
                    <g id="people">
                      <path id="Vector"
                        d="M17.8635 7.77C17.7935 7.76 17.7235 7.76 17.6535 7.77C16.1035 7.72 14.8735 6.45 14.8735 4.89C14.8735 3.3 16.1635 2 17.7635 2C19.3535 2 20.6535 3.29 20.6535 4.89C20.6435 6.45 19.4135 7.72 17.8635 7.77Z"
                        fill="#1677FF" />
                      <path id="Vector_2"
                        d="M21.1236 14.7C20.0036 15.45 18.4336 15.73 16.9836 15.54C17.3636 14.72 17.5636 13.81 17.5736 12.85C17.5736 11.85 17.3536 10.9 16.9336 10.07C18.4136 9.86998 19.9836 10.15 21.1136 10.9C22.6936 11.94 22.6936 13.65 21.1236 14.7Z"
                        fill="#1677FF" />
                      <path id="Vector_3"
                        d="M6.77365 7.77C6.84365 7.76 6.91365 7.76 6.98365 7.77C8.53365 7.72 9.76365 6.45 9.76365 4.89C9.76365 3.29 8.47365 2 6.87365 2C5.28365 2 3.99365 3.29 3.99365 4.89C3.99365 6.45 5.22365 7.72 6.77365 7.77Z"
                        fill="#1677FF" />
                      <path id="Vector_4"
                        d="M6.88361 12.85C6.88361 13.82 7.09361 14.74 7.47361 15.57C6.06361 15.72 4.59361 15.42 3.51361 14.71C1.93361 13.66 1.93361 11.95 3.51361 10.9C4.58361 10.18 6.09361 9.88998 7.51361 10.05C7.10361 10.89 6.88361 11.84 6.88361 12.85Z"
                        fill="#1677FF" />
                      <path id="Vector_5"
                        d="M12.4533 15.87C12.3733 15.86 12.2833 15.86 12.1933 15.87C10.3533 15.81 8.8833 14.3 8.8833 12.44C8.8933 10.54 10.4233 9 12.3333 9C14.2333 9 15.7733 10.54 15.7733 12.44C15.7633 14.3 14.3033 15.81 12.4533 15.87Z"
                        fill="#1677FF" />
                      <path id="Vector_6"
                        d="M9.2033 17.94C7.6933 18.95 7.6933 20.61 9.2033 21.61C10.9233 22.76 13.7433 22.76 15.4633 21.61C16.9733 20.6 16.9733 18.94 15.4633 17.94C13.7533 16.79 10.9333 16.79 9.2033 17.94Z"
                        fill="#1677FF" />
                    </g>
                  </g>
                </svg>总共入组(人)</div>
              <div class="data-value">{{ viewInfoData2["year_pass"] }}</div>
            </div>
          </div>
          <div class="row" style="position: relative;">
            <div ref="monthEnrollChart2" class="chart" style="height: 190px;"></div>
            <div class="timeButtons">
              <button v-for="type in buttonTypes" :key="type.value" :class="{ active: currentType2 === type.value }"
                @click="handleTypeChange2(type.value)">
                {{ type.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="column">
          <div ref="passGroupSexChart" class="chart" style="height: 300px;"></div>
        </div>
        <div class="column">
          <div ref="passGroupAgeChart" class="chart" style="height: 300px;"></div>
        </div>
      </div>
    </div>

    <!-- 本中心质控与人员模块 -->
    <div class="module">
      <h2 class="section-title">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
          style="margin-left: -15px;">
          <g id="Card_Team">
            <path id="Intersect" opacity="0.5"
              d="M7.68129 2.08337L2.0835 7.68117V2.963C2.0835 2.4772 2.47732 2.08337 2.96313 2.08337H7.68129Z"
              fill="#1677FF" />
            <g id="Subtract" opacity="0.5">
              <path
                d="M10.0489 9.63247C10.1839 9.33042 10.2591 8.99479 10.2591 8.64126C10.2591 8.28774 10.1839 7.95211 10.0489 7.65006C10.4189 6.82215 11.2381 6.24658 12.1892 6.24658C13.4874 6.24658 14.5397 7.31872 14.5397 8.64126C14.5397 9.96381 13.4874 11.0359 12.1892 11.0359C11.2381 11.0359 10.4189 10.4604 10.0489 9.63247Z"
                fill="#1677FF" />
              <path
                d="M10.7586 15.3306H15.0392V14.1344C15.0392 12.5334 13.7413 11.2355 12.1403 11.2355C11.2927 11.2355 10.5301 11.5992 10 12.1791C10.4712 12.6946 10.7586 13.381 10.7586 14.1344V15.3306Z"
                fill="#1677FF" />
            </g>
            <path id="Subtract_2" fill-rule="evenodd" clip-rule="evenodd"
              d="M2.0835 17.0371V7.68117L7.68129 2.08337H17.0372C17.523 2.08337 17.9168 2.4772 17.9168 2.963V17.0371C17.9168 17.5229 17.523 17.9167 17.0372 17.9167H2.96313C2.47732 17.9167 2.0835 17.5229 2.0835 17.0371ZM10.2592 8.64126C10.2592 9.96381 9.2069 11.0359 7.90877 11.0359C6.61064 11.0359 5.5583 9.96381 5.5583 8.64126C5.5583 7.31872 6.61064 6.24658 7.90877 6.24658C9.2069 6.24658 10.2592 7.31872 10.2592 8.64126ZM4.9609 14.1344C4.9609 12.5334 6.25879 11.2355 7.85983 11.2355C9.46087 11.2355 10.7588 12.5334 10.7588 14.1344V15.3306H4.9609V14.1344ZM10.2592 8.64126C10.2592 8.99479 10.1843 9.33042 10.0493 9.63247C10.4193 10.4604 11.2385 11.0359 12.1896 11.0359C13.4877 11.0359 14.5401 9.96381 14.5401 8.64126C14.5401 7.31872 13.4877 6.24658 12.1896 6.24658C11.2385 6.24658 10.4193 6.82215 10.0493 7.65006C10.1843 7.95211 10.2592 8.28774 10.2592 8.64126ZM15.0396 15.3306H10.7588V14.1344C10.7588 13.381 10.4716 12.6946 10.0004 12.1791C10.5304 11.5992 11.2931 11.2355 12.1407 11.2355C13.7417 11.2355 15.0396 12.5334 15.0396 14.1344V15.3306Z"
              fill="#1677FF" />
          </g>
        </svg>本中心质控与人员
      </h2>
      <div class="module-content-new">
        <!-- <div class="column">
          <div ref="monthlyBarChart" style="width:100%;height:400px;"></div>
        </div>
        <div class="column"> 
            <span style="margin-left:20px;" class="title-font">项目成员</span>        
            <div class="member_container">            
            <ul class="member-list">
                <li class="member-item" v-if="projectUserInfo.piUser">
                    <span class="member-role">PI</span>
                    <span>{{projectUserInfo.piUser}}</span>
                </li>
                <li class="member-item" v-if="projectUserInfo.centerUser">
                    <span class="member-role">中心管理员</span>
                    <span>{{projectUserInfo.centerUser}}</span>
                </li>
                <li class="member-item" v-if="projectUserInfo.manageUser">
                    <span class="member-role">项目管理员</span>
                    <span>{{projectUserInfo.manageUser}}</span>
                </li>
                <li class="member-item" v-if="projectUserInfo.dataUser">
                    <span class="member-role">数据管理员</span>
                    <span>{{projectUserInfo.dataUser}}</span>
                </li>
                <li class="member-item" v-if="projectUserInfo.checkUser">
                    <span class="member-role">数据审核员</span>
                    <span>{{projectUserInfo.checkUser}}</span>
                </li>
                <li class="member-item" v-if="projectUserInfo.gatherUser">
                    <span class="member-role">调查员</span>
                    <span>{{projectUserInfo.gatherUser}}人</span>
                </li>
            </ul>
    </div>
        </div> -->
        <!-- <div class="column">
          <span style="margin-left: 10px;" class="title-font">调查员工作统计</span>
          <a-table
          ref="table"
          size="middle"
          rowKey="resultid"
          :columns="columns"
          :dataSource="dataSource"
          :scroll="{y:'400px',x:'100%'}"
          :pagination="false"
          :loading="loading"
          >
          <span slot="baselineRepRate">
            应答率
            <a-tooltip class="info-row" >
              <template slot="title">
                基线应答率=基线提交人数/注册人数-筛选期的人数-终止筛选的人数中（符合排除，不符合纳入，去重后的人数）
              </template>
<a-icon type="question-circle" />
</a-tooltip>
</span>
<span slot="periodNum">
  随访完成量
  <a-tooltip class="info-row">
    <template slot="title">
                动态随访完成量：本月该调查员提交的随访人数/本月系统随机分配给该调查员的随访人数（%）
              </template>
    <a-icon type="question-circle" />
  </a-tooltip>
</span>
</a-table>
</div> -->
        <div class="column-new">
          <div ref="followRateChartRef" style="width:100%;height:400px;"></div>
        </div>
        <div class="column-new">
          <div ref="enrolledInGroupRef" style="width:100%;height:400px;"></div>
          <div class="timeButtons">
            <!-- <button class="time-btn" :class="{ active: currentType === type.value }" data-type="month">月</button>
            <button class="time-btn" data-type="week">周</button>
            <button class="time-btn" data-type="quarter">季度</button>
            <button class="time-btn" data-type="year">年</button> -->
            <button v-for="type in buttonType3" :key="type.value" :class="{ active: currentType3 === type.value }"
              @click="handleNewChange(type.value, 1)">
              {{ type.label }}
            </button>
          </div>
        </div>
        <div class="column-new">
          <div ref="averageInvestEnrolledRef" style="width:100%;height:400px;"></div>
          <div class="timeButtons">
            <button v-for="type in buttonType4" :key="type.value" :class="{ active: currentType4 === type.value }"
              @click="handleNewChange(type.value, 2)">
              {{ type.label }}
            </button>
          </div>
        </div>
        <div class="column-new">
          <div ref="visitsInvestigatorRef" style="width:100%;height:400px;"></div>
          <div class="timeButtons">
            <button v-for="type in buttonType5" :key="type.value" :class="{ active: currentType5 === type.value }"
              @click="handleNewChange(type.value, 3)">
              {{ type.label }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <a-modal title="中心切换" :width="300" :visible="select_visible" :confirmLoading="confirmLoading" switchFullscreen
      @ok="selectCenterOk" @cancel="select_visible = false" cancelText="关闭">
      <a-spin :spinning="confirmLoading">
        <a-form-model layout="horizontal">
          <a-form-model-item>
            <a-select placeholder="请选择中心" v-model="currentCenterId" style="width: 200px" allowClear>
              <a-select-option v-for="(item, index) in centerList" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>
    <a-modal :title="periodRateName" :visible="periodDetailVisible" @ok="periodDetailVisible = false"
      @cancel="periodDetailVisible = false" :cancelButtonProps="{ style: { display: 'none' } }"
      :okButtonProps="{ style: { display: 'none' } }">
      <div ref="periodChart" class="card coal-trend" style="width:460px; height:290px;"></div>
    </a-modal>
    <a-modal v-model:open="timeFlag" title="指定时间" @ok="handleTimeRange()" @cancel="handleCancelTimeRange">
      <div>
        <a-range-picker valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" class="picker" v-model:value="timeRange"
          style="width: 100%;" />
      </div>
    </a-modal>
  </div>
</template>

<script>
// import { Calendar, Histogram, TrendCharts, ArrowUp, ArrowDown } from '@element-plus/icons-vue'
import { CACHE_PROJECT_ID, CACHE_PROJECT_NAME } from '@/constants/project'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import Vue from 'vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import CPie from './components/CPie'
import { getAction, postAction, downloadFile } from '@/api/manage'
import baseRules from '@/constants/baseRules'
import * as echarts from 'echarts'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: "Dashboard",
  mixins: [JeecgListMixin],
  components: { CPie },
  inject: ['viewInfoFn'],
  data() {
    return {

      // 本中心质控与人员数据
      qualityData: {
        barData: {
          xAxis: ['SOP1', 'SOP2', 'SOP3', 'SOP4'],
          series: [20, 50, 80, 30]
        },
        text: '当前质控达标率: 92.5%\n本月质控问题数: 12个',
        tableData: [
          { name: '研究员A', tasks: 12, complete: 10 },
          { name: '研究员B', tasks: 8, complete: 7 },
          { name: '研究员C', tasks: 15, complete: 14 }
        ]
      },
      columns: [],
      dataSource: [],
      tokenHeader: { 'X-Access-Token': Vue.ls.get(ACCESS_TOKEN) },
      fileType: '5',
      projectId: Vue.ls.get(CACHE_PROJECT_ID) || '',
      noticeVisible: false,
      noticeViewVisible: false,
      confirmLoading: false,
      marks: {
        0: '0%',
        50: '50%',
        100: '100%',
      },

      inited: false,
      project: {},
      viewInfoData1: {},
      viewInfoData2: {},
      infoList: {},
      progressList: [],
      progressColorList: ['rgba(19,183,197,0.9)', 'rgba(245,115,41,0.9)', 'rgba(58,124,253,0.9)'],
      projectUserInfo: {
        roleList: []
      },
      noticeList: [],
      passGroupCenterChart: null,
      passGroupSexChart: null,
      passGroupAgeChart: null,
      centerRateChart: null,
      followRateChartRef: null,
      enrolledInGroupRef: null,
      averageInvestEnrolledRef: null,
      visitsInvestigatorRef: null,
      periodRateChart: null,
      monthEnrollChart: null,
      monthEnrollChart2: null,
      groupRateData: {},
      groupAgeData: [],
      select_visible: false,
      currentCenterId: undefined,
      currentCenter: null,
      centerList: [],
      queryParam: {},
      disableMixinCreated: true,
      periodDetailVisible: false,
      periodChart: null,
      periodRateName: '详细信息',
      currentType: 'week',
      currentType2: 'week',
      buttonTypes: [
        { label: '周', value: 'week' },
        { label: '月', value: 'month' },
        { label: '季度', value: 'quarter' },
        { label: '年', value: 'year' }
      ],
      buttonType3: [
        { label: '周', value: '1' },
        { label: '月', value: '2' },
        { label: '年', value: '3' }
      ],
      buttonType4: [
        { label: '周', value: '1' },
        { label: '月', value: '2' },
        { label: '季度', value: '3' },
        { label: '年', value: '4' }
      ],
      timeFlag: false,
      timeRange: [],
      buttonType5: [
        { label: '周', value: '1' },
        { label: '月', value: '2' },
        { label: '指定时间', value: '0' }
      ],
      currentType3: '1',
      currentType4: '1',
      currentType5: '1'
    }
  },
  created() {
    this.queryParam.projectId = this.projectId
    this.loadProject()
    this.loadColumn()
  },

  methods: {
    async loadColumn() {
      // 添加 周期的column
      const columns = [
        {
          title: '调查员',
          align: "center",
          width: 80,
          dataIndex: 'personName'
        },

        {
          title: '基线人数',
          align: "center",
          width: 80,
          dataIndex: 'baselineSubmitNum'
        },
        {
          // title: '基线应答率统计',
          slots: { title: 'baselineRepRate' },
          align: "center",
          width: 80,
          dataIndex: 'baselineRepRate'
        }

      ]
      columns.push({
        title: '随访总计',
        width: 80,
        align: "center",
        dataIndex: 'periodSum'
      })
      this.width = 800
      this.columns = columns
    },
    loadProject(centerId) {
      getAction('/management/project/projectUserInfo', { id: this.projectId, centerId: centerId }).then(res => {
        if (res.success) {
          this.projectUserInfo = res.result
          console.log("this.projectUserInfo:" + this.projectUserInfo)
          this.loadView(centerId ? centerId : this.projectUserInfo.centerId)
        }
      })
    },
    loadView(centerId) {
      console.log("centerId:" + centerId)

      getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 1 }).then(res => {
        if (res.success) {
          this.viewInfoData1 = res.result
        }
      })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: 1 }).then(res => {
        if (res.success) {
          this.viewInfoData2 = res.result
        }
      })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 2 }).then(res => {
        if (res.success) {
          this.initPassGroupCenterChart(res.result["pass_group_center"])
        }
      })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 31 }).then(res => {
        if (res.success) {
          this.initMonthEnrollCharts(res.result["pass_group_center_month"])
        }
      })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: 31 }).then(res => {
        if (res.success) {
          this.initMonthEnrollCharts2(res.result["pass_group_center_month"])
        }
      })

      getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 4 }).then(res => {
        if (res.success) {
          this.initPeriodRateChart(res.result["center_form_rate"])
        }
      })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: 5 }).then(res => {
        if (res.success) {
          this.initGroupSexChart(res.result["pass_sex_center"])
        }
      })
      // getAction('/management/project/getViewInfo',{projectId:this.projectId,centerId:centerId,row:6}).then(res=>{
      //   if(res.success){   
      //     // this.groupAgeData = res.result["pass_age_center"]    
      //     this.initGroupAgeChart(res.result["pass_age_center"])          
      //   }
      // })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: 9 }).then(res => {
        if (res.success) {
          this.initGroupAgeChart2(res.result["all_age_center"])
        }
      })
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: 7 }).then(res => {
        if (res.success) {
          this.initCenterRateChart(res.result["rate_center"])
          // this.groupRateData = res.result["rate_center"]
        }
      })
      this.queryParam.projectId = this.projectId
      this.queryParam.centerId = centerId
      getAction('/project/statistic/workload', this.queryParam).then(res => {
        if (res.success) {
          this.dataSource = res.result.records || res.result;
        }
      })
      // 初始化第一个图
      // 随访率
      this.followRateChart(centerId)
      // 调查员入组总人数分布
      this.enrolledInGroup(centerId)
      // 调查员平均入组人数趋势
      this.averageInvestEnrolled(centerId)
      // 调查员随访人次
      this.visitsInvestigator(centerId)
    },
    handleTypeChange(type) {
      this.currentType = type
      this.monthEnrollChart.dispose();
      var row = 31
      if (type == "month") {
        row = 3
      } else if (type == "week") {
        row = 31
      } else if (type == "quarter") {
        row = 32
      } else if (type == "year") {
        row = 33
      }
      getAction('/management/project/getViewInfo', { projectId: this.projectId, row: row }).then(res => {
        if (res.success) {
          this.initMonthEnrollCharts(res.result["pass_group_center_month"])
        }
      })
    },
    handleTimeRange() {
      let centerId = this.currentCenterId ? this.currentCenterId : this.projectUserInfo.centerId
      if (this.timeRange.length === 2) {
        this.currentType5 = '0'
        this.timeFlag = false
        this.visitsInvestigator(centerId, this.timeRange)
      } else {
        this.$message.error('请选择时间范围')
      }
    },
    handleCancelTimeRange() {
      this.timeFlag = false
    },
    handleNewChange(type, index) {
      let centerId = this.currentCenterId ? this.currentCenterId : this.projectUserInfo.centerId
      switch (index) {
        case 1:
          this.currentType3 = type
          this.enrolledInGroup(centerId)
          break
        case 2:
          this.currentType4 = type
          this.averageInvestEnrolled(centerId)
          break
        case 3:
          if (type === '0') {
            this.timeFlag = true
          } else {
            this.currentType5 = type
            this.visitsInvestigator(centerId)
          }
          break
      }
    },
    handleTypeChange2(type) {
      this.currentType2 = type
      this.monthEnrollChart2.dispose();
      var row = 31
      if (type == "month") {
        row = 3
      } else if (type == "week") {
        row = 31
      } else if (type == "quarter") {
        row = 32
      } else if (type == "year") {
        row = 33
      }
      let centerId = this.currentCenterId ? this.currentCenterId : this.projectUserInfo.centerId
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: row }).then(res => {
        if (res.success) {
          this.initMonthEnrollCharts2(res.result["pass_group_center_month"])
        }
      })
    },
    selectCenter() {
      this.getCenterList()
      this.select_visible = true
    },
    getCenterList() {
      getAction('/project/center/auth_center', { projectId: this.projectId }).then(res => {
        if (res.success && res.result) {
          this.centerList = res.result
        } else {
          this.$message.error('后台请求异常')
        }
      })
    },
    selectCenterOk() {
      console.log("this.currentCenterId：" + this.currentCenterId)
      if (this.currentCenterId) {
        this.currentCenter = this.centerList.find(c => c.id === this.currentCenterId)
        this.loadProject(this.currentCenterId)
        this.currentType2 = 'week'
      } else {
        // this.currentCenter = null
        // this.loadView()
      }
      this.select_visible = false
    },
    showCenterDialog() { },
    initPassGroupCenterChart(data) {
      // 初始化图表实例
      this.passGroupCenterChart = echarts.init(this.$refs.passGroupCenterChart);
      // console.log(data)

      this.passGroupCenterChart.setOption({
        title: {
          text: '{circle|}\t入组统计', // \t 用于添加间隔
          left: 'left',
          // top: '5%',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        // grid: {
        //   top: 80, // 图表区域距离容器顶部 80px
        // },
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        legend: {
          data: data.map(item => ({
            name: item.centerName,
            tooltip: {
              formatter: item.centerName
            }
          })),
          bottom: 10,
          left: 'center',
          formatter: function (name) {
            // 截取前几个字符
            if (data.length > 3 && data.length < 9) {
              return name.length > 4 ? name.slice(0, 4) + '..' : name;
            } else if (data.length >= 9) {
              return '';
            }
            return name;
          },
          tooltip: {
            show: true
          }
        },
        grid: { top: 60, left: '2%', right: '2%', bottom: 60, containLabel: true },
        xAxis: { type: 'category', data: [''] },
        yAxis: { type: 'value', name: '入组人数(人)' },
        series: data.map(item => ({
          name: item.centerName,
          type: 'bar',
          data: [item.count],
          //   barWidth: 30,
          barMaxWidth: 30,  // 最大宽度

          barMinHeight: 10,  // 最小高度
          itemStyle: { color: item.color },
          label: { show: true, position: 'top', formatter: '{c}' },
          barWidth: '160%',
          barGap: '30%', // 柱子之间的间隙
          // barCategoryGap: '40%' // 类别之间的柱子的总间隙
        }))
      });
      window.addEventListener('resize', () => {
        this.passGroupCenterChart.resize();
      });

    },

    initMonthEnrollCharts(data) {
      if (!data) return
      var centers = Object.keys(data)
      var months = data[centers[0]].map(d => d.month)
      var seriesData = centers.map(center => {
        return {
          name: center,
          type: 'line',
          //stack: '人数',
          // data: data[center].map(d => d.count===0?null:d.count),
          data: data[center].map(d => d.count),
          symbol: 'none',
          // smooth: true,
        }
      })

      this.monthEnrollChart = echarts.init(this.$refs.monthEnrollChart);
      this.monthEnrollChart.setOption({
        title: {
          text: '{circle|}\t入组趋势统计', // \t 用于添加间隔
          left: 'left',
          // top: '5%',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: centers.map(item => ({
            name: item,
            tooltip: {
              formatter: item
            }
          })),
          bottom: 10,
          left: 'center',
          formatter: function (name) {
            // 截取前几个字符
            if (centers.length > 3 && centers.length < 9) {
              return name.length > 4 ? name.slice(0, 4) + '..' : name;
            } else if (centers.length >= 9) {
              return '';
            }
            return name;
          },
          tooltip: {
            show: true
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '80',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: months
        },
        yAxis: { type: 'value', name: '入组人数(人)' },
        series: seriesData
      });
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.monthEnrollChart.resize();
      });
    },
    initMonthEnrollCharts2(data) {
      if (!data) return
      var centers = Object.keys(data)
      var months = data[centers[0]].map(d => d.month)
      var seriesData = centers.map(center => {
        return {
          name: center,
          type: 'line',
          //stack: '人数',
          // data: data[center].map(d => d.count===0?null:d.count),
          data: data[center].map(d => d.count),
          symbol: 'none',
          // smooth: true,
        }
      })

      var maxDataValue = Math.max(...data[centers[0]].map(d => d.count));
      var yAxisMax = Math.floor(maxDataValue * 1.2)

      this.monthEnrollChart2 = echarts.init(this.$refs.monthEnrollChart2);
      this.monthEnrollChart2.setOption({
        title: {
          text: '{circle|}\t入组趋势统计', // \t 用于添加间隔
          left: 'left',
          // top: '5%',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        // legend: {          
        //         data: centers.map(item => ({
        //           name: item,
        //           tooltip: {
        //             formatter: item
        //           }
        //         })),
        //         bottom: 10,
        //         left: 'center',
        //         formatter: function (name) {
        //           // 截取前几个字符
        //           if(centers.length > 3 && centers.length < 9){
        //             return name.length > 4 ? name.slice(0, 4) + '..' : name;
        //           }else if(centers.length >= 9){
        //             return '';
        //           }
        //           return name;
        //         },
        //         tooltip: {
        //           show: true
        //         }
        //       },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0',
          containLabel: true
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: months
        },
        yAxis: { type: 'value', name: '入组人数(人)', },
        series: seriesData
      });
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.monthEnrollChart2.resize();
      });
    },
    initPeriodRateChart(data) {
      data = data.filter(item => item.resRate != '0')
      var centers = data.map(d => d.centerName)
      const avgPeople = data.map(d => d.resRate)
      const seatRate = data.map(d => d.floRate)

      // 初始化图表实例
      this.periodRateChart = echarts.init(this.$refs.periodRateChart);
      this.periodRateChart.setOption({
        title: {
          text: '{circle|}\t应答率/随访率统计', // \t 用于添加间隔
          left: 'left',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（应答率/随访率统计设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const index = params[0].dataIndex;
            return `
              ${centers[index]}<br/>
              应答率: ${avgPeople[index]}%<br/>
              随访率: ${seatRate[index]}%
            `;
          }
        },
        legend: {
          data: ['应答率', '随访率'],
          bottom: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        grid: { left: '10%', right: '13%', bottom: 50, containLabel: true },
        xAxis: {
          type: 'value',
          min: -20,
          max: 20,
          splitLine: { show: false },
          axisLabel: { show: false }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: centers,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            show: true,
            formatter: value => `${value}`,
            color: '#333',
            fontSize: 14,
            margin: 40
          }
        },
        //yAxis: { type: 'value', name: '百分比' },
        series: [
          {
            name: '应答率',
            type: 'bar',
            stack: 'total',
            data: avgPeople.map(item => -item),
            barWidth: 14,
            itemStyle: { color: '#14C9C9' },
            label: {
              show: true,
              position: 'left',
              formatter: params => Math.abs(params.value) + '%',
              color: '#333'
            }
          },
          {
            name: '随访率',
            type: 'bar',
            stack: 'total',
            data: seatRate,
            barWidth: 14,
            itemStyle: { color: '#165DFF' },
            label: {
              show: true,
              position: 'right',
              formatter: '{c}%',
              color: '#333'
            }
          }
        ]
      });
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.periodRateChart.resize();
      });
    },

    initGroupSexChart(data) {
      // 初始化图表实例
      this.passGroupSexChart = echarts.init(this.$refs.passGroupSexChart);
      // console.log(data)
      var playData = []
      data.forEach(item => {
        playData.push({ value: item.count, name: item.centerName })
      })

      // 配置项
      const option = {
        color: ['#52c41a', '#1890ff', '#faad14'],
        title: {
          text: '{circle|}\t受试者性别统计', // \t 用于添加间隔
          left: 'left',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        series: [
          {
            name: '性别人数',
            type: 'pie',
            radius: '50%',
            data: playData,
            label: {
              show: true,
              formatter: '{c}人'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      // 设置配置项并渲染图表
      this.passGroupSexChart.setOption(option);

      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.passGroupSexChart.resize();
      });
    },
    initGroupAgeChart(data) {
      // 初始化图表实例
      this.passGroupAgeChart = echarts.init(this.$refs.passGroupAgeChart);
      console.log(11, data)
      var actualData = []
      var playData = []
      var totalValue = 0
      var names = []
      data.forEach(item => {
        actualData.push(item.count)
        names.push(item.centerName)
        playData.push({ value: item.count, name: item.centerName })
        totalValue += item.count
      })


      //console.log(totalValue)   
      const option = {
        title: {
          text: '{circle|}\t受试者年龄统计', // \t 用于添加间隔
          left: 'left',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {

          bottom: 10,
          textStyle: {
            color: '#333',
            fontSize: 14
          }
        },
        series: [
          {
            name: '年龄人数',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 40,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: playData
          }
        ]
      }

      // 设置配置项并渲染图表
      this.passGroupAgeChart.setOption(option);

      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.passGroupAgeChart.resize();
      });
    },
    initGroupAgeChart2(ages) {
      // 对数组进行排序
      const sortedAges = [...ages].sort((a, b) => a - b);

      // 创建一个对象来保存每个年龄的数量
      var ageCountMap = {};
      sortedAges.forEach(function (age) {
        if (ageCountMap[age]) {
          ageCountMap[age]++;
        } else {
          ageCountMap[age] = 1;
        }
      });

      // 将年龄和人数转换成两个数组，以便于ECharts使用
      var agesUnique = Object.keys(ageCountMap).map(Number);
      var counts = agesUnique.map(function (age) { return ageCountMap[age]; });
      console.log(agesUnique, counts)

      this.passGroupAgeChart = echarts.init(this.$refs.passGroupAgeChart);
      // 数据
      // const ages = [10, 50, 30, 66, 79, 86, 22, 35, 26, 16, 67, 87, 90, 32, 50];

      // 计算均值、标准差、中位数、Q1 和 Q3
      // const mean = ages.reduce((sum, age) => sum + age, 0) / ages.length;
      // const variance = ages.reduce((sum, age) => sum + Math.pow(age - mean, 2), 0) / (ages.length - 1);
      // const stdDeviation = Math.sqrt(variance);

      // // 排序以计算中位数、Q1、Q3

      const median = calculateMedian(sortedAges);
      const q1 = calculateQuantile(sortedAges, 0.25);
      const q3 = calculateQuantile(sortedAges, 0.75);

      console.log(median, q1, q3)

      // // 正态分布函数
      // function normalDistribution(x, mean, stdDeviation) {
      //     return (1 / (Math.sqrt(2 * Math.PI) * stdDeviation)) *
      //            Math.exp(-Math.pow(x - mean, 2) / (2 * Math.pow(stdDeviation, 2)));
      // }

      // 计算中位数
      function calculateMedian(arr) {
        const half = Math.floor(arr.length / 2);
        if (arr.length % 2 === 0) {
          return (arr[half - 1] + arr[half]) / 2;
        } else {
          return arr[half];
        }
      }

      // 计算任意分位数
      function calculateQuantile(arr, quantile) {
        const index = (arr.length - 1) * quantile;
        const lower = Math.floor(index);
        const upper = Math.ceil(index);
        const weight = index - lower;

        if (lower === upper) {
          return arr[lower];
        } else {
          return arr[lower] * (1 - weight) + arr[upper] * weight;
        }
      }

      // // 生成 x 范围（从最小值到最大值）
      const xMin = Math.min(...ages);
      const xMax = Math.max(...ages);
      // const step = 1;//(xMax - xMin) / 500; // 分成 500 个点
      // const xValues = [];
      // const yValues = [];

      // for (let x = xMin; x <= xMax; x += step) {

      //     xValues.push(x);
      //     yValues.push((normalDistribution(x, mean, stdDeviation)*ages.length).toFixed(0));
      // }

      const option = {
        title: {
          text: '{circle|}\t受试者年龄统计',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        // tooltip: {
        //     trigger: 'axis'
        // },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: params => {
            const index = params[0].dataIndex;
            return `
                  年龄: ${params[0].axisValue}岁<br/>
                  人数: ${counts[index]}人
                `;
          }
        },
        xAxis: {
          name: '年龄',
          type: 'value',
          min: xMin,
          max: xMax,
          axisLabel: {
            formatter: '{value}',
          },
          // data: agesUnique,
          // label: {
          //   show: true,
          //   formatter: '{c}人'
          // },
        },
        grid: {
          top: '20%',
          left: '10%',
          right: '10%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: {
          name: '人数',
          type: 'value',
          // min: 0
        },
        series: [{
          name: '人数',
          data: counts.map((count, index) => [agesUnique[index], count]), //xValues.map((x, index) => [x, yValues[index]]),
          type: 'line',
          // smooth: true,
          // label: {
          //     show: false
          // },
          markLine: {
            symbol: ['none', 'none'],
            // label: { show: false },
            data: [
              {
                xAxis: median,
                name: '中位数', // 标记线的名称
                label: {
                  show: true, // 显示文字
                  formatter: `中位数: ${median}岁`, // 自定义文字内容
                  position: 'end', // 文字位置（可选：start、middle、end）
                  textStyle: {
                    color: '#14C9C9',
                    fontSize: 12
                  }
                },
                lineStyle: {
                  // color: 'red' // 标记线的颜色
                }
              },
              {
                xAxis: q1,
                name: 'q1', // 标记线的名称
                label: {
                  show: true, // 显示文字
                  formatter: `q1: ${q1}岁`, // 自定义文字内容
                  position: 'start', // 文字位置（可选：start、middle、end）
                  offset: [-15, 13],
                  textStyle: {
                    color: '#14C9C9',
                    fontSize: 12
                  }
                },
                lineStyle: {
                  // color: 'red' // 标记线的颜色
                }
              },
              {
                xAxis: q3,
                name: 'q3', // 标记线的名称
                label: {
                  show: true, // 显示文字
                  formatter: `q3: ${q3}岁`, // 自定义文字内容
                  // position: function (point) {
                  //   console.log("points:"+point[0]);
                  //     // point 是标记线的起始和终点坐标
                  //     return [point[0], point[1]]; // 动态计算偏移
                  // },
                  position: 'start', // 文字位置（可选：start、middle、end）
                  offset: [15, 13],
                  textStyle: {
                    color: '#14C9C9',
                    fontSize: 12
                  }
                },
                lineStyle: {
                  // color: 'red' // 标记线的颜色
                }
              }
            ]
          },
          symbol: 'none' // 隐藏数据点标记
        }]
      };

      // 设置配置项并渲染图表
      this.passGroupAgeChart.setOption(option);

      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.passGroupAgeChart.resize();
      });
    },
    initCenterRateChart(groupRateData) {
      var rateNames = ['应答率', '随访率', '合格率', '时效率', '完整率'];
      var rateFormula = [{ name: '应答率', formula: '应答率=基线人数/注册人数-筛选期人数-终止筛选人数' },
      { name: '随访率', formula: '随访率=随访人数/随访人数-随访终止人数' },
      { name: '合格率', formula: '合格率=(周期提交表单总数-有效质疑数)/周期提交表单总数' },
      { name: '时效率', formula: '时效率=(周期提交表单总数-超时提交的表单数)/(提交的表单总数)' },
      { name: '完整率', formula: '完整率=(周期提交表单总数-数据缺失提交的表单数)/(提交的表单总数)' }]
      var rateData = [];
      rateData.push(groupRateData.totalCount <= 0 ? 0 : (groupRateData.passCount / groupRateData.totalCount * 100).toFixed(1));
      rateData.push(groupRateData.submitCount == 0 ? 0 : ((groupRateData.submitCount - groupRateData.loseCount) / groupRateData.submitCount * 100).toFixed(1));
      rateData.push(groupRateData.submitCount == 0 ? 0 : ((groupRateData.submitCount - groupRateData.questionCount) / groupRateData.submitCount * 100).toFixed(1));
      rateData.push(groupRateData.submitCount == 0 ? 0 : ((groupRateData.submitCount - groupRateData.delayCount) / groupRateData.submitCount * 100).toFixed(1));
      rateData.push(groupRateData.submitCount == 0 ? 0 : ((groupRateData.submitCount - groupRateData.missCount) / groupRateData.submitCount * 100).toFixed(1));
      //console.log(rateData);
      this.centerRateChart = echarts.init(this.$refs.monthlyBarChart);
      const option = {
        title: {
          text: '{circle|}\t质控统计',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function (params) {
            let result = '';
            params.forEach(function (item) {
              //result += `${item.axisValue}：${item.value}%<br>`;
              let rate = rateFormula.filter(f => f.name === item.axisValue)[0];
              result += `${rate.formula}<br>`;
            });
            return result;
          }
        },
        legend: {},
        grid: {
          top: '10%',
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          max: 100, // 设置 X 轴最大值为 100（对应 100%）
          min: 0, // 设置 X 轴最小值为 0（对应 0%）
          axisLabel: {
            formatter: function (value) {
              return value + '%'; // 将值转换为百分比格式
            }
          }
        },
        yAxis: {
          type: 'category',
          data: rateNames,
          inverse: true
        },
        series: [
          {
            type: 'bar',
            itemStyle: { color: '#165DFF' }, // 设置柱状图颜色
            data: rateData,
            label: {
              show: true,
              //position: 'right',
              formatter: '{c}%'
            }
          }
        ]
      };
      // 设置配置项并渲染图表
      this.centerRateChart.setOption(option);

      this.centerRateChart.on('click', params => {
        // console.log(params);
        this.periodRate(groupRateData.centerId, params.name)
      });

      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.centerRateChart.resize();
      });
    },
    async followRateChart(centerId) {
      const res = await getAction('/management/index/report/visitRate', { projectId: this.projectId, centerId: centerId, row: 7 })
      let data = []
      if (res.success) {
        data = res.result
      }
      this.followRateChartRef = echarts.init(this.$refs.followRateChartRef);
      const option = {
        title: {
          text: '{circle|}\t随访率',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {},
        grid: {
          top: '10%',
          left: '0%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.map(item => item.name)
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLabel: {
            color: '#94a3b8',
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '随访率',
            data: data.map(item => item.submitCountRate),
            type: 'line',
            color: '#165DFF',
            smooth: true
          }
        ]
      }
      // 设置配置项并渲染图表
      this.followRateChartRef.setOption(option)
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.followRateChartRef.resize()
      })
    },
    async enrolledInGroup(centerId) {
      const res = await getAction('/management/index/report/registPatient', { projectId: this.projectId, centerId: centerId, period: this.currentType3 })
      let data = []
      if (res.success) {
        data = res.result
      }
      this.enrolledInGroupRef = echarts.init(this.$refs.enrolledInGroupRef)
      const option = {
        title: {
          text: '{circle|}\t调查员入组总人数分布',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          bottom: 10
        },
        grid: {
          top: '15%',
          left: '0%',
          right: '4%',
          bottom: '40',
          containLabel: true
        },
        dataset: {
          source: [
            ['product', '注册人数', '入组人数'],
            ...data.map(item => [item.personName, item.registerCount, item.groupCount])
          ]
        },
        xAxis: { type: 'category' },
        yAxis: {
          name: '单位(人)'
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ type: 'bar', color: '#165efe' }, { type: 'bar', color: '#13c9c9' }]
      }
      // 设置配置项并渲染图表
      this.enrolledInGroupRef.setOption(option)
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.enrolledInGroupRef.resize();
      })
    },
    async averageInvestEnrolled(centerId) {
      const res = await getAction('/management/index/report/average/join/patient', { projectId: this.projectId, centerId: centerId, period: this.currentType4 })
      let data = []
      let seriesData = []
      if (res.success) {
        data = res.result
        // 获取所有人员
        const persons = [...new Set(Object.values(res.result).flat().map(item => item.personName))]

        // 生成ECharts数据系列
        seriesData = persons.map((person, index) => {
          const colors = ['#1867ff', '#13c9c9', '#10b981', '#f59e0b', '#8b5cf6'] // 颜色数组
          return {
            name: person,
            type: 'line',
            smooth: true,
            color: colors[index % colors.length], // 循环使用颜色
            data: Object.values(res.result).map(quarter => {
              const personData = quarter.find(item => item.personName === person)
              return personData ? personData.averageCount : 0
            })
          }
        })
      }
      this.averageInvestEnrolledRef = echarts.init(this.$refs.averageInvestEnrolledRef);
      const option = {
        title: {
          text: '{circle|}\t调查员平均入组人数趋势',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          bottom: 10
        },
        grid: {
          top: '15%',
          left: '4%',
          right: '5%',
          bottom: '40',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: Object.keys(data)
        },
        yAxis: {
          type: 'value',
          name: '单位(人)'
        },
        series: seriesData
      }
      // 设置配置项并渲染图表
      this.averageInvestEnrolledRef.setOption(option);
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.averageInvestEnrolledRef.resize();
      })
    },
    async visitsInvestigator(centerId, timeRange) {
      const params = {
        projectId: this.projectId,
        centerId: centerId,
        period: this.currentType5,
        startDate: timeRange ? timeRange[0] : '',
        endDate: timeRange ? timeRange[1] : ''
      }
      const res = await getAction('/management/index/report/visitPatient', params)
      let data = []
      if (res.success) {
        data = res.result
      }
      this.visitsInvestigatorRef = echarts.init(this.$refs.visitsInvestigatorRef)
      const option = {
        title: {
          text: '{circle|}\t调查员随访人次',
          textStyle: {
            rich: {
              circle: {
                backgroundColor: '#1890ff', // 圆点颜色
                width: 6,                   // 圆点宽度
                height: 6,                  // 圆点高度
                borderRadius: 3,            // 圆角半径（设为50%为圆形）
                verticalAlign: 'middle'      // 垂直对齐方式
              }
            },
            fontWeight: 'normal', // 取消加粗
            fontSize: 16,
            color: '#333',
            padding: [0, 0, 0, 10] // 左留白控制圆点位置
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          bottom: 10
        },
        grid: {
          top: '15%',
          left: '0%',
          right: '4%',
          bottom: '40',
          containLabel: true
        },
        dataset: {
          source: [
            ['product', '总随访人次', '日平均随访人次'],
            ...data.map(item => [item.personName, item.totalCount, item.average])
          ]
        },
        xAxis: { type: 'category' },
        yAxis: {
          name: '单位(人)'
        },
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ type: 'bar', color: '#165efe' }, { type: 'bar', color: '#13c9c9' }]
      }
      // 设置配置项并渲染图表
      this.visitsInvestigatorRef.setOption(option)
      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.visitsInvestigatorRef.resize()
      })
    },
    periodRate(centerId, name) {
      this.periodDetailVisible = true
      this.periodRateName = name
      var type = 1;
      if (name == '随访率') type = 1
      if (name == '合格率') type = 2
      if (name == '时效率') type = 3
      if (name == '完整率') type = 4
      getAction('/management/project/getViewInfo', { projectId: this.projectId, centerId: centerId, row: 8 }).then(res => {
        if (res.success) {
          this.initPeriodCharts(res.result["period_rate_center"], type)
        }
      })
    },
    initPeriodCharts(data, type) {
      if (!data) return
      // var centers = Object.keys(data)
      // var months = data[centers[0]].map(d => d.month)
      // var seriesData = centers.map(center => {
      //   return {
      //     name: center,
      //     type: 'line',
      //     //stack: '人数',
      //     data: data[center].map(d => d.count)
      //   }
      // })
      var rateData = []
      var periodNames = []
      var ymin = 0
      var ymax = 100;
      if (type == 1) {
        periodNames = data.filter(d => d.submitRate > 0).map(d => d.periodName)
        rateData = data.filter(d => d.submitRate > 0).map(d => d.submitRate)
      } else if (type == 2) {
        periodNames = data.filter(d => d.noQuestionRate > 0).map(d => d.periodName)
        rateData = data.filter(d => d.noQuestionRate > 0).map(d => d.noQuestionRate)
      } else if (type == 3) {
        periodNames = data.filter(d => d.delayRate > 0).map(d => d.periodName)
        rateData = data.filter(d => d.delayRate > 0).map(d => d.delayRate)
      } else if (type == 4) {
        periodNames = data.filter(d => d.missRate > 0).map(d => d.periodName)
        rateData = data.filter(d => d.missRate > 0).map(d => d.missRate)
      }
      ymin = Math.min(...rateData)
      ymax = Math.max(...rateData)
      ymin = ymin - 1 < 0 ? 0 : ymin - 1
      ymax = ymax + 1 > 100 ? 100 : ymax + 1

      this.periodChart = echarts.init(this.$refs.periodChart);
      // 配置项
      const option = {
        tooltip: {
          trigger: 'item'
        },
        grid: { top: 10, left: '5%', right: '5%', bottom: 10, containLabel: true },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: periodNames,
          // axisLabel: {
          //     rotate: 45,          // 文字旋转角度              
          //     formatter: (value) => {  // 超长文字截断
          //       return value.length > 10 ? value.slice(0,10)+'...' : value;
          //     },
          //     padding: [0, 0, 0, 20], // 左方向增加 20px 边距
          //     align: 'middle' // 文字左对齐
          //   },
        },
        yAxis: {
          type: 'value',
          name: '单位：%',
          nameGap: 25,
          axisLabel: {
            align: 'right' // 将标签向左侧对齐
          },
          min: ymin, // 设置 Y 轴最小值
          max: ymax, // 设置 Y 轴最大值
        },
        series: [
          {
            data: rateData,
            type: 'line',
            areaStyle: { color: 'rgba(24, 144, 255, 0.1)' },
            lineStyle: {
              color: '#1890ff'
            },
          }
        ]
      };
      // 设置配置项并渲染图表
      this.periodChart.setOption(option);

      // 窗口变化时自适应
      window.addEventListener('resize', () => {
        this.periodChart.resize();
      });
    }
  }
};
</script>

<style scoped lang="less">
.switch-center {
  color: #1890ff;
  cursor: pointer;
  margin-left: 8px;
}

.switch-center:hover {
  text-decoration: underline;
}

.report-container {
  padding: 0 10px;
  background-color: #f0f2f5;
}

.module {
  /* margin-bottom: 30px; */
  /* border: 1px solid #eee; */
  /* border-radius: 4px; */
  /* padding: 15px; */
}

.module:last-child {
  padding-bottom: 25px;
}

.section-title {
  /* background-color: #f5f5f5; */
  padding: 12px 20px;
  margin: 0;
  font-size: 18px;
  color: #333;
  display: flex;
  align-items: center;
  height: 5px;
  /*border-bottom: 1px solid #f5f5f5;*/
  /* 添加下划线 */
}

.title-font {
  font-size: 16px;
  color: #333;
}

.module-content {
  display: flex;
  /* margin-top: 15px; */
}

.module-content-new {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-left: 10px;
  margin-top: 10px;
}

.column-new {
  width: calc(100% / 2 - 10px);
  position: relative;
  border: 1px solid #eee;
  border-radius: 20px;
  padding: 15px 0px 0px 15px;
  background: white;
}

.column {
  position: relative;
  border: 1px solid #eee;
  border-radius: 20px;
  margin: 5px;
  padding: 15px 0px 0px 15px;
  background: white;
}

/* .column:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 0;
  top: 1%;
  height: 94%;
  width: 1px;
  background-color: #e8e8e8; */
/* margin-right: 20px;
  margin-left: 20px; */
/* } */
.column:first-child {
  flex: 0 0 38%;
  max-width: 38%;
}

.column:not(:first-child) {
  flex: 0 0 30%;
  max-width: 30%;
}

.row {
  margin-bottom: 15px;
  display: flex;
  gap: 10px;
  /* 卡片间距 */
}

.data-item,
.text {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 4px;
  min-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
  flex: 1;
  background: #F6F8FA;
}

.data-card {
  flex: 1;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 15px;
  text-align: center;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.data-label {
  margin-bottom: 15px;
  /* 增加标签和数值间距 */
}

.data-value {
  font-family: Roboto, Roboto;
  font-weight: 500;
  font-size: 26px;
  color: rgba(0, 0, 0, 0.88);
  line-height: 42px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: -8px
}

.data-label {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  display: flex;
  align-items: center;
}

.data-icon {
  margin-right: 6px;
}

.stats-row {
  display: flex;
  margin-bottom: 15px !important;
}

.chart-1 {
  width: 100%;
  height: 400px;
  /* 增加高度 */
  margin-bottom: 10px;
  position: relative;
}

.chart {
  width: 100%;
  height: 480px;
  /* 增加高度 */
  margin-bottom: 10px;
  /* 减少底部间距 */
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.table th {
  background-color: #f2f2f2;
}

.table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.member_container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
  line-height: 22px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.member-list {
  list-style-type: none;
  padding: 0;
}

.member-item {
  display: flex;
  margin-bottom: 12px;
}

.member-item:last-child {
  margin-bottom: 0;
}

.member-role {
  width: 30%;
  color: rgba(0, 0, 0, 0.45);
}

.member-item span:not(.member-role) {
  width: 70%;
}

.timeButtons button {
  margin-right: 3px;
  border-color: #c0baba;
  border-radius: 12px;
  border-style: solid;
  border-width: 1px;
  padding: 3px 8px;
  border: 1px solid #d9d9d9;
  background: #fff;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
}

/* 按钮组样式 */
.timeButtons {
  position: absolute;
  top: 10px;
  right: 2px;
  z-index: 1000;
  /* background: rgba(255, 255, 255, 0.9); */
  /* border-radius: 4px; */
  /* padding: 5px; */
  /* box-shadow: 0 2px 4px rgba(0,0,0,0.1); */
}

/* 悬停状态 */
.timeButtons button:hover {
  background: #b9babb;
  border-color: #c0c4cc;
}

/* 选中状态 */
.timeButtons button.active {
  background: #409eff;
  color: white;
  border-color: #409eff;
}
</style>